module.exports = __webpack_public_path__ + "imgs/filters-circle.5c475c309c64ad19b4d8790bbac669d8.svg";